import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import Rebase from "re-base";
import { ActionCreators } from "../actions";
import SoonestSlotsProviders from "../components/SoonestSlotsProviders";
import dbSync from "../config/database";

const dbLive = Rebase.createClass(dbSync);

function Schedule(props) {
  const [state, setState] = useState({
    // Keep dates as timestamps. Date.toString() is not parsed consistently by
    // Safari and can turn the Firebase query bounds into NaN.
    selectableDay: moment().valueOf(),
    selectableMAXDay: moment()
      .add(19, "days")
      .set({ hour: 5, minute: 0, second: 0, millisecond: 0 })
      .valueOf(),
    dateToday: moment().valueOf(),
    selectedDay: moment().valueOf(),
    oneHourAppointments: false,
    disableNextDay: false,
    disablePrevDay: false,
    coordLatitudeUser: "",
    coordLongitudeUser: "",
    coordsEnabled: false,
    DATA_fetch_locations: "",
    loading: true
  });

  const checkDateLimit = () => {
    const { selectableMAXDay, selectedDay, dateToday } = state;

    if (
      selectableMAXDay <=
      moment(selectedDay)
        .set({ hour: 5, minute: 0, second: 0, millisecond: 0 })
        .valueOf()
    ) {
      setState(prevState => ({ ...prevState, disableNextDay: true }));
    } else {
      setState(prevState => ({ ...prevState, disableNextDay: false }));
    }

    if (moment(selectedDay).date() === moment(dateToday).date()) {
      setState(prevState => ({ ...prevState, disablePrevDay: true }));
    } else {
      setState(prevState => ({ ...prevState, disablePrevDay: false }));
    }
  };

  const initSlots = (sDay, startingTime, endingTime) => {
    if (!Number.isFinite(startingTime) || !Number.isFinite(endingTime)) {
      return;
    }

    dbLive.listenTo(`/app/timeslots`, {
      context: { window },
      asArray: true,
      queries: {
        orderByChild: "durationTimestamp/start",
        startAt: startingTime,
        endAt: endingTime
      },
      then: payload => {
        setState(prevState => ({ ...prevState, loading: true }));
        if (state.DATA_fetch_locations) {
          const tempFilteredProviders = [];
          const fPname = state.filteredProviderName;

          const filterProvider = item => {
            if (fPname === "Nurse/Doctor") {
              return item.providerName !== fPname;
            }
            return item.providerName === fPname;
          };

          const filteredProvidersArr = payload.filter(filterProvider);
          tempFilteredProviders.push(filteredProvidersArr);

          setState(prevState => ({
            ...prevState,
            arr_FilteredByProviders: tempFilteredProviders
          }));

          const tempFilteredProvidersAndLocation = [];

          Object.keys(state.DATA_fetch_locations).forEach(locName => {
            const filterProviderAndLocation = item =>
              item.location === locName &&
              item.appointment === false &&
              item.provider !== "unassociated";

            const filteredProvidersLocationsArr = filteredProvidersArr.filter(
              filterProviderAndLocation
            );
            const fObj = {
              [locName]: filteredProvidersLocationsArr
            };

            tempFilteredProvidersAndLocation.push(fObj);
          });

          setState(prevState => ({
            ...prevState,
            arr_FilteredByProvidersAndLocation: tempFilteredProvidersAndLocation
          }));

          let slotCount = 0;
          tempFilteredProvidersAndLocation.forEach(location => {
            Object.keys(location).forEach(key => {
              slotCount += location[key].length;
            });
          });

          setState(prevState => ({
            ...prevState,
            slotLength: slotCount
          }));
        }
        setState(prevState => ({ ...prevState, loading: false }));
      }
    });

    checkDateLimit();
  };

  const handleTimeSlot = sDay => {
    let startingTime;
    let endingTime;

    if (moment(sDay).date() === moment(state.dateToday).date()) {
      const currentHour = moment(state.dateToday).hour();
      const currentMinute = moment(state.dateToday).minute();
      startingTime = moment(sDay)
        .set({
          hour: currentHour,
          minute: currentMinute,
          second: 0,
          millisecond: 0
        })
        .add(0, "hours")
        .valueOf();
      endingTime = moment(sDay)
        .set({ hour: 23, minute: 0, second: 0, millisecond: 0 })
        .valueOf();
    } else {
      startingTime = moment(sDay)
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .valueOf();
      endingTime = moment(sDay)
        .set({ hour: 23, minute: 0, second: 0, millisecond: 0 })
        .valueOf();
    }

    initSlots(sDay, startingTime, endingTime);
  };

  const handlePrevDay = () => {
    const {
      DATA_fetch_soonest_ADVANCED,
      selectedFilterLocationName,
      selectedTimeslotLocation
    } = props;
    const { selectedDay, dateToday } = state;
    let nextDay = null;
    const keys = Object.keys(DATA_fetch_soonest_ADVANCED).reverse();

    for (const key of keys) {
      const selectedDate = moment(selectedDay);
      const date = moment(
        DATA_fetch_soonest_ADVANCED[key].durationTimestamp.start
      );

      if (
        date.diff(selectedDate, "days") < 0 &&
        !DATA_fetch_soonest_ADVANCED[key].appointment
      ) {
        if (
          (selectedFilterLocationName.name === "Location" ||
            DATA_fetch_soonest_ADVANCED[key].locationName ===
              selectedFilterLocationName.name) &&
          (selectedTimeslotLocation.name === "Nurse/Doctor" ||
            DATA_fetch_soonest_ADVANCED[key].providerName ===
              selectedTimeslotLocation.name)
        ) {
          nextDay = date.valueOf();
          break;
        }
      }
    }

    if (!nextDay) return;

    setState(prevState => ({
      ...prevState,
      selectedDay: nextDay
    }));

    const updateSlots = sDay => {
      let startingTime;
      let endingTime;

      if (moment(sDay).date() === moment(dateToday).date()) {
        const currentHour = moment(dateToday).hour();
        const currentMinute = moment(dateToday).minute();

        startingTime = moment(sDay)
          .set({
            hour: currentHour,
            minute: currentMinute,
            second: 0,
            millisecond: 0
          })
          .add(2, "hours")
          .valueOf();
        endingTime = moment(sDay)
          .set({ hour: 23, minute: 0, second: 0, millisecond: 0 })
          .valueOf();
      } else {
        startingTime = moment(sDay)
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .valueOf();
        endingTime = moment(sDay)
          .set({ hour: 23, minute: 0, second: 0, millisecond: 0 })
          .valueOf();
      }

      initSlots(sDay, startingTime, endingTime);
      checkDateLimit();
    };

    updateSlots(nextDay);
  };

  const handleNextDay = () => {
    const {
      DATA_fetch_soonest_ADVANCED,
      selectedFilterLocationName,
      selectedTimeslotLocation
    } = props;
    const { selectedDay, dateToday } = state;
    let nextDay = null;

    for (const key in DATA_fetch_soonest_ADVANCED) {
      if (
        Object.prototype.hasOwnProperty.call(DATA_fetch_soonest_ADVANCED, key)
      ) {
        const selectedDate = moment(selectedDay);
        const date = moment(
          DATA_fetch_soonest_ADVANCED[key].durationTimestamp.start
        );

        if (
          date.diff(selectedDate, "days") > 0 &&
          !DATA_fetch_soonest_ADVANCED[key].appointment
        ) {
          if (
            (selectedFilterLocationName.name === "Location" ||
              DATA_fetch_soonest_ADVANCED[key].locationName ===
                selectedFilterLocationName.name) &&
            (selectedTimeslotLocation.name === "Nurse/Doctor" ||
              DATA_fetch_soonest_ADVANCED[key].providerName ===
                selectedTimeslotLocation.name)
          ) {
            nextDay = date.valueOf();
            break;
          }
        }
      }
    }

    if (!nextDay) return;

    setState(prevState => ({ ...prevState, selectedDay: nextDay }));

    if (moment(nextDay).date() === moment(dateToday).date()) {
      const currentHour = moment(dateToday).hour();
      const currentMinute = moment(dateToday).minute();

      const startingTime = moment(nextDay)
        .set({
          hour: currentHour,
          minute: currentMinute,
          second: 0,
          millisecond: 0
        })
        .add(2, "hours")
        .valueOf();
      const endingTime = moment(nextDay)
        .set({ hour: 23, minute: 0, second: 0, millisecond: 0 })
        .valueOf();

      initSlots(nextDay, startingTime, endingTime);
    } else {
      const startingTime = moment(nextDay)
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .valueOf();
      const endingTime = moment(nextDay)
        .set({ hour: 23, minute: 0, second: 0, millisecond: 0 })
        .valueOf();

      initSlots(nextDay, startingTime, endingTime);
    }

    checkDateLimit();
  };

  useEffect(() => {
    dbLive.listenTo(`/app/locations`, {
      context: { window },
      asArray: true,
      then() {
        props.functionFetchLocations();
      }
    });

    props.f_FETCH_Providers();

    const geoSuccess = () => {};

    const geoError = error => {
      if (error.code === error.PERMISSION_DENIED) {
        setState(prevState => ({ ...prevState, coordsEnabled: false }));
      } else {
        setState(prevState => ({ ...prevState, coordsEnabled: true }));
      }
    };

    navigator.geolocation.watchPosition(geoSuccess, geoError);

    props.functionFetchLocations();
    props.functionFilteredTS();
  }, []);

  useEffect(
    () => {
      if (props.DATA_fetch_soonest_triggered) {
        if (props.DATA_fetch_soonest_triggered.triggeredSoonestTime) {
          const newSelectedDay = moment(
            props.DATA_fetch_soonest_triggered.triggeredSoonestTime
          ).valueOf();
          setState(prevState => ({
            ...prevState,
            selectedDay: newSelectedDay
          }));
          handleTimeSlot(newSelectedDay);
        } else {
          handleTimeSlot(state.selectedDay);
        }
      }

      if (props.selectedTimeslotLocation !== null) {
        setState(prevState => ({
          ...prevState,
          filteredProviderName: props.selectedTimeslotLocation.name
        }));
      }

      if (props.selectedFilterLocationName !== null) {
        setState(prevState => ({
          ...prevState,
          filteredLocationName: props.selectedFilterLocationName.id
        }));
      }

      if (props.DATA_fetch_locations) {
        setState(prevState => ({
          ...prevState,
          DATA_fetch_locations: props.DATA_fetch_locations
        }));
      }

      if (props.DATA_fetch_providers) {
        setState(prevState => ({
          ...prevState,
          DATA_fetch_providers: props.DATA_fetch_providers
        }));
      }
    },
    [
      props.DATA_fetch_soonest_triggered,
      props.selectedTimeslotLocation,
      props.selectedFilterLocationName,
      props.DATA_fetch_locations,
      props.DATA_fetch_providers
    ]
  );

  return (
    <div
      className={`soonestAvailableContainer ${
        props.selectedHoursValue.selectedHours
          ? "duration_half"
          : "duration_full"
      }`}
    >
      {props.filteredTimeslots.filteredTimeslots && (
        <div className="timeslots">
          <div className="blockInner">
            {!props.dataFetchAppointmentTime.location ? (
              <div className="soonerDaySelector">
                {!state.disablePrevDay ? (
                  <button className="soonestPrev" onClick={handlePrevDay}>
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="19px"
                      height="32px"
                      viewBox="0 0 9.5 16"
                      enableBackground="new 0 0 9.5 16"
                    >
                      <path
                        fill="#FFFFFF"
                        d="M0.824,3C2.812,5.016,4.801,7.032,6.79,9.048c0-0.713,0-1.426,0-2.139c-1.989,2.016-3.977,4.032-5.966,6.048 c-1.359,1.378,0.75,3.518,2.109,2.139c1.988-2.016,3.977-4.032,5.966-6.048c0.569-0.578,0.571-1.56,0-2.139 C6.91,4.893,4.921,2.877,2.933,0.861C1.574-0.517-0.536,1.621,0.824,3L0.824,3z"
                      />
                    </svg>
                  </button>
                ) : (
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="19px"
                    height="32px"
                    viewBox="0 0 9.5 16"
                    enableBackground="new 0 0 9.5 16"
                  >
                    <path
                      fill="#FFFFFF"
                      d="M0.824,3C2.812,5.016,4.801,7.032,6.79,9.048c0-0.713,0-1.426,0-2.139c-1.989,2.016-3.977,4.032-5.966,6.048 c-1.359,1.378,0.75,3.518,2.109,2.139c1.988-2.016,3.977-4.032,5.966-6.048c0.569-0.578,0.571-1.56,0-2.139 C6.91,4.893,4.921,2.877,2.933,0.861C1.574-0.517-0.536,1.621,0.824,3L0.824,3z"
                    />
                  </svg>
                )}

                <p>{moment(state.selectedDay).format("dddd, MMMM DD")}</p>

                {!state.disableNextDay ? (
                  <button className="soonestNext" onClick={handleNextDay}>
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="19px"
                      height="32px"
                      viewBox="0 0 9.5 16"
                      enableBackground="new 0 0 9.5 16"
                    >
                      <path
                        fill="#FFFFFF"
                        d="M0.824,3C2.812,5.016,4.801,7.032,6.79,9.048c0-0.713,0-1.426,0-2.139c-1.989,2.016-3.977,4.032-5.966,6.048 c-1.359,1.378,0.75,3.518,2.109,2.139c1.988-2.016,3.977-4.032,5.966-6.048c0.569-0.578,0.571-1.56,0-2.139 C6.91,4.893,4.921,2.877,2.933,0.861C1.574-0.517-0.536,1.621,0.824,3L0.824,3z"
                      />
                    </svg>
                  </button>
                ) : (
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="19px"
                    height="32px"
                    viewBox="0 0 9.5 16"
                    enableBackground="new 0 0 9.5 16"
                  >
                    <path
                      fill="#FFFFFF"
                      d="M0.824,3C2.812,5.016,4.801,7.032,6.79,9.048c0-0.713,0-1.426,0-2.139c-1.989,2.016-3.977,4.032-5.966,6.048 c-1.359,1.378,0.75,3.518,2.109,2.139c1.988-2.016,3.977-4.032,5.966-6.048c0.569-0.578,0.571-1.56,0-2.139 C6.91,4.893,4.921,2.877,2.933,0.861C1.574-0.517-0.536,1.621,0.824,3L0.824,3z"
                    />
                  </svg>
                )}
              </div>
            ) : null}

            {state.arr_FilteredByProvidersAndLocation &&
            state.DATA_fetch_providers &&
            props.DATA_fetch_locations ? (
              <SoonestSlotsProviders
                slotLength={state.slotLength}
                coordsDisabled={state.coordsDisabled}
                DATA_fetch_locations={props.DATA_fetch_locations}
                DATA_fetch_providers={state.DATA_fetch_providers}
                oneHourAppointments={props.selectedHoursValue.selectedHours}
                data={state.arr_FilteredByProvidersAndLocation}
                locations={props.DATA_fetch_locations}
              />
            ) : (
              <svg
                style={{ display: "block", margin: "0 auto" }}
                width="200px"
                height="200px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
                className="lds-ripple"
              >
                <circle
                  cx="50"
                  cy="50"
                  r="39.9922"
                  fill="none"
                  stroke="#ffac82"
                  strokeWidth="2"
                >
                  <animate
                    attributeName="r"
                    calcMode="spline"
                    values="0;40"
                    keyTimes="0;1"
                    dur="3"
                    keySplines="0 0.2 0.8 1"
                    begin="-1.5s"
                    repeatCount="indefinite"
                  />
                  <animate
                    attributeName="opacity"
                    calcMode="spline"
                    values="1;0"
                    keyTimes="0;1"
                    dur="3"
                    keySplines="0.2 0 0.8 1"
                    begin="-1.5s"
                    repeatCount="indefinite"
                  />
                </circle>
                <circle
                  cx="50"
                  cy="50"
                  r="25.7457"
                  fill="none"
                  stroke="#00afea"
                  strokeWidth="2"
                >
                  <animate
                    attributeName="r"
                    calcMode="spline"
                    values="0;40"
                    keyTimes="0;1"
                    dur="3"
                    keySplines="0 0.2 0.8 1"
                    begin="0s"
                    repeatCount="indefinite"
                  />
                  <animate
                    attributeName="opacity"
                    calcMode="spline"
                    values="1;0"
                    keyTimes="0;1"
                    dur="3"
                    keySplines="0.2 0 0.8 1"
                    begin="0s"
                    repeatCount="indefinite"
                  />
                </circle>
              </svg>
            )}
          </div>
        </div>
      )}

      {!props.dataFetchAppointmentTime.location ? (
        <div className="walkin_clinic">
          <div className="blockInner">
            <h1>Not seeing what you want or need to cancel?</h1>
            <p>Call us at 720-777-BC4U (2248)</p>
          </div>
        </div>
      ) : null}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    DATA_fetch_soonest_ADVANCED: state.DATA_fetch_soonest_ADVANCED,
    dataFetchTimeslots: state.dataFetchTimeslots,
    DATA_fetch_locations: state.DATA_fetch_locations,
    DATA_fetch_providers: state.DATA_fetch_providers,
    DATA_fetch_soonest: state.DATA_fetch_soonest,
    DATA_fetch_soonest_triggered: state.DATA_fetch_soonest_triggered,
    dataFetchAppointmentTime: state.dataFetchAppointmentTime,
    selectedTimeslotLocation: state.selectedTimeslotLocation,
    selectedFilterLocationName: state.selectedFilterLocationName,
    selectedDateValue: state.selectedDateValue,
    selectedHoursValue: state.selectedHoursValue,
    filteredTimeslots: state.filteredTimeslots,
    dataGeoLocations: state.dataGeoLocations,
    dataUserOpeningTimeslot: state.dataUserOpeningTimeslot
  };
}

// for redux dispatch
function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

// for redux
export default connect(mapStateToProps, mapDispatchToProps)(Schedule);
